import DOMPurify from "dompurify";

/**
 * Returns URL only if it strictly starts with http:// or https://,
 * otherwise returns '#' to prevent javascript: or unsafe scheme execution.
 */
export const safeUrl = (u) => (/^https?:\/\//i.test(u || "") ? u : "#");

/**
 * Returns iframe embed URL only if it is a valid Google Maps embed URL,
 * otherwise returns empty string to block malicious iframe embedding.
 */
export const safeEmbed = (u) =>
  /^https:\/\/(www\.)?(google\.com\/maps\/embed|maps\.google\.com\/maps)/i.test(u || "") ? u : "";

/**
 * Sanitizes rich HTML content with DOMPurify to strip scripts, onerror/onload handlers, etc.
 */
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || "");
